import { Component, OnInit, SimpleChanges } from "@angular/core";
import { FileItem } from "../../../../models/entities/file-item";
import { ArchivoPDF } from "../../../../models/entities/archivoPdf";
import { Alert } from "../../../../models/alert";
import { Observable } from "rxjs";
import { ElementoCatalogo } from "../../../../models/entities/elemento-catalogo";
import { Estado } from "../../../../models/entities/estado";
import { first, take } from "rxjs/operators";
import { RutaCatalogoEnum } from "../../../../shared/enums/ruta-catalogo.enum";
import { CatalogoService } from "../../../../services/catalogo.service";
import { ArchivosWebService } from "../../../../services/archivos-web.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "archivos-carpeta-ejecutiva",
  templateUrl: "./archivos-carpeta-ejecutiva.component.html",
  styleUrls: ["./archivos-carpeta-ejecutiva.component.scss"],
})
export class ArchivosCarpetaEjecutivaComponent implements OnInit {
  public carpetaEjecutivaForm: FormGroup;
  public archivos: any[] = [];
  public archivos2: FileItem[] = [];
  public archivosPdf: ArchivoPDF[] = [];
  public tipoError: boolean = false;
  public completado: boolean;
  public alerta: Alert = new Alert();
  public value: any[] = [];
  mensaje: string;
  public tipoError2: boolean = false;
  public tiposObra$: Observable<ElementoCatalogo[]>;
  public estados$: Observable<Estado[]>;
  tipoObra: string = null;
  estado: string = null;

  constructor(
    private catalogoService: CatalogoService,
    private formBuilder: FormBuilder,
    public cargaDeArchivo: ArchivosWebService
  ) {}

  ngOnInit() {
    this.obtenerCatalogoEstados();
    this.inicializarForm();
  }

  public obtenerCatalogoEstados() {
    this.estados$ = this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1));
    this.tiposObra$ = this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1));
  }

  private inicializarForm() {
    this.carpetaEjecutivaForm = this.formBuilder.group({
      tipoObra: new FormControl("-1"),
      estado: new FormControl("-1"),
      keyLevantamientoObra: new FormControl("-1"),
    });

    this.carpetaEjecutivaForm.get("estado").disable();
    this.carpetaEjecutivaForm.get("keyLevantamientoObra").disable();

    this.carpetaEjecutivaForm
      .get("tipoObra")
      .valueChanges.subscribe((keyTipoObra: string) => {
        if (keyTipoObra === "-1") {
          this.carpetaEjecutivaForm.get("estado").disable();
          this.carpetaEjecutivaForm.get("estado").setValue("-1");
        } else {
          this.carpetaEjecutivaForm.get("estado").enable();
        }
      });
  }

  public cargarArchivos(archivos: FileList): void {
    this.archivos[0] = archivos[0];
    const file: FileItem = new FileItem(this.archivos[0]);

    if (file.archivo.type === "application/pdf") {
      this.archivos2 = [];
      this.archivos2.push(file);
      this.tipoError = false;
    } else {
      this.archivos2 = [];
      this.tipoError = true;
    }
    this.completado = null;
  }

  public limpiarArchivos(): void {
    this.archivos = [];
    this.archivos2 = [];
    this.completado = null;
  }

  public eliminarArchivo(indice: number): void {
    this.alerta.confirmacion().then((result) => {
      if (result.value === true) {
        this.archivos.splice(indice, 1);
        this.archivos2.splice(indice, 1);
      }
    });
  }

  findingFiles() {
    console.log(this.carpetaEjecutivaForm.value);
    this.tipoObra = this.carpetaEjecutivaForm.value.tipoObra;
    this.estado = this.carpetaEjecutivaForm.value.estado;
    console.log(this.tipoObra, this.estado);
  }

  cargarFicha(tipoObra: string, estado: string) {
    // this.cargaDeArchivo.cargarArchivoFirebase(this.archivos2, key);
    // this.llamarPdfs2(key, null);

    this.cargaDeArchivo
      .validarNombreArchivo2(this.archivos2[0].nombreArchivo)
      .pipe(first())
      .subscribe((data) => {
        this.value = data;
        // console.log(this.value);

        if (this.value.length > 0) {
          const validar = this.value.find(
            (element) => element.nombre === this.archivos2[0].nombreArchivo
          );

          if (validar === undefined) {
            this.subirFichaFirebase(tipoObra, estado);
          } else {
            this.mensaje = "Ya existe un archivo con ese nombre.";
            this.alerta.errorCustom(this.mensaje);
          }
        } else {
          this.subirFichaFirebase(tipoObra, estado);
        }
      });
  }

  subirFichaFirebase(tipoObra: string, estado: string) {
    this.cargaDeArchivo.cargarArchivoCarpetaEjecutiva(
      this.archivos2,
      tipoObra,
      estado
    );
  }
}
